import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class EmployeeSalaryIncrementDto implements IEmployeeSalaryIncrementDto {
    department!: string | undefined;
    location!: string | undefined;
    designation!: string | undefined;
    nextIncrementDate!: Date | undefined;
    branch!: string | undefined;
    currentSalary!: number;
    employee!: EmployeeSummaryDto;
    joinDate!: Date;
    newSalary!: number | undefined;
    incrementId!: number | undefined;

    constructor(data?: IEmployeeSalaryIncrementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.department = _data["department"];
            this.location = _data["location"];
            this.designation = _data["designation"];
            this.nextIncrementDate = _data["nextIncrementDate"] ? new Date(_data["nextIncrementDate"].toString()) : <any>undefined;
            this.branch = _data["branch"];
            this.currentSalary = _data["currentSalary"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.joinDate = _data["joinDate"] ? new Date(_data["joinDate"].toString()) : <any>undefined;
            this.newSalary = _data["newSalary"];
            this.incrementId = _data["incrementId"];
        }
    }

    static fromJS(data: any): EmployeeSalaryIncrementDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSalaryIncrementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["department"] = this.department;
        data["location"] = this.location;
        data["designation"] = this.designation;
        data["nextIncrementDate"] = this.nextIncrementDate ? this.nextIncrementDate.toISOString() : <any>undefined;
        data["branch"] = this.branch;
        data["currentSalary"] = this.currentSalary;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["joinDate"] = this.joinDate ? this.joinDate.toISOString() : <any>undefined;
        data["newSalary"] = this.newSalary;
        data["incrementId"] = this.incrementId;
        return data; 
    }
}

export interface IEmployeeSalaryIncrementDto {
    department: string | undefined;
    location: string | undefined;
    designation: string | undefined;
    nextIncrementDate: Date | undefined;
    branch: string | undefined;
    currentSalary: number;
    employee: EmployeeSummaryDto;
    joinDate: Date;
    newSalary: number | undefined;
    incrementId: number | undefined;
}

